import { useStandingOfferCancel } from "@/api";
import { Button } from "@/components/ui/button";
import Dialog from "@/components/ui/dialog";
import { toast } from "@/components/ui/use-toast";

interface Props {
  id: string;
  onOpenChange: () => void;
}

export function CancelStandingOffer({ id, onOpenChange }: Props) {
  const [cancelOffer] = useStandingOfferCancel(id);

  function handleCancel() {
    cancelOffer()
      .then(() =>
        toast({
          title: "Offer cancelled",
          description:
            "Subscriptions can no longer be created through this offer"
        })
      )
      .catch((error) => {
        toast({
          title: "Unable to cancel offer",
          description:
            "An error occurred while cancelling the offer. Please try again.",
          variant: "destructive"
        });
        console.error(error);
      })
      .finally(onOpenChange);
  }

  return (
    <Dialog.Root open onOpenChange={onOpenChange}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>Cancel offer</Dialog.Title>
          <Dialog.Description>
            Cancelling a standing offer will prevent new subscriptions to the
            app. Existing subscriptions created through the standing offer will
            continue to be active.
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer className="mt-8 flex items-center">
          <Dialog.Close asChild>
            <Button variant="secondary">Abort</Button>
          </Dialog.Close>
          <Button variant="destructive" onClick={handleCancel}>
            Cancel offer
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
}
